<div class="hmf-display-flex">
	<hmf-global-chips
		[id]="id()"
		[label]="label()"
		[disabled]="isDisabled()"
		type="neutral"
		[variant]="selected() ? 'prominent': 'subtle'"
		[loading]="isLoading()"
		[size]="isMobile() ? 'small' : 'medium'"
		(handleChipClick)="emitSelectedOption()">
	</hmf-global-chips>
</div>
